import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import cn from "../../utils/cn";
import { inputVariants } from "../Input/Input";
const Textarea = React.forwardRef(({ className, ...props }, ref) => {
    return _jsx("textarea", { className: cn(inputVariants({ className }), "min-h-[80px]", className), ref: ref, ...props });
});
Textarea.displayName = "Textarea";
export default Textarea;
